"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _phrase = _interopRequireDefault(require("libs/translationsUtils/phrase"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _Analytics = _interopRequireDefault(require("../analytics/Analytics"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'last-visitors';
exports.cssAnchorName = cssAnchorName;

var gaEventTracker = function gaEventTracker() {
  return _Analytics.default.send({
    eventCategory: 'Homepage',
    eventAction: 'Recently active user clicked'
  });
};

var LastVisitors = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LastVisitors, _Component);

  var _super = _createSuper(LastVisitors);

  function LastVisitors() {
    var _this;

    (0, _classCallCheck2.default)(this, LastVisitors);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      visitors: []
    });
    return _this;
  }

  (0, _createClass2.default)(LastVisitors, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _axios.default.get('/widget/lastVisitors').then(function (res) {
        var newData = res.data.map(function (visitor) {
          visitor.id = visitor.userid;
          visitor.name = visitor.username;
          return visitor;
        });

        _this2.setState({
          visitors: newData
        });
      }).catch(function (e) {
        // eslint-disable-next-line no-console
        console.log('Err ', e);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state;

      if (!state.visitors.length) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "widget-last-visitors"
      }, (0, _preact.h)("div", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "branded.last-visitors.title"
      })), state.visitors.map(function (visitor) {
        return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
          (0, _preact.h)("span", {
            className: "last-visitor",
            onClick: gaEventTracker,
            key: visitor.userid
          }, (0, _preact.h)(_UserAvatar.default, {
            showRank: false,
            user: visitor,
            extraClass: "avatar--S",
            width: 30,
            height: 30
          }))
        );
      }));
    }
  }]);
  return LastVisitors;
}(_preact.Component);

var _default = LastVisitors;
exports.default = _default;